module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_04_600M.e63219f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_04_600M.jpg
// module id = 345
// module chunks = 0